<template>
  <div
    v-if="delay_show"
    class="float-btn"
    :style="{
      width: itemWidth + 'px',
      height: itemHeight + 'px',
      left: left + 'px',
      top: top + 'px',
    }"
    ref="div"
    @touchstart="
      (e) => {
        dragStart(e);
      }
    "
    @touchend="
      (e) => {
        dragEnd(e);
      }
    "
    @touchmove.prevent="
      (e) => {
        dragProgress(e);
      }
    "
  >
    <img @click="clickButton" src="@/assets/insurance/share.png" alt="" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      clientWidth: 0,
      clientHeight: 0,
      left: 0,
      top: 0,
      gapWidth: 0,
      itemWidth: document.documentElement.style.fontSize.split("px")[0] * 1.43, // 图标的宽度
      itemHeight: document.documentElement.style.fontSize.split("px")[0] * 1.43, // 图标的高度
      fab_detail: {}, //悬浮窗信息
      delay_show: false,
      timer: null,
    };
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = this.clientWidth - this.itemWidth - this.gapWidth;
    this.top =
      this.clientHeight -
      document.documentElement.style.fontSize.split("px")[0] * 1.81 -
      document.documentElement.style.fontSize.split("px")[0] * 1.43;
  },
  mounted() {
    // 延迟显示：修复因为transition导致的初始位置异常
    this.timer = setTimeout(() => {
      this.delay_show = true;
    }, 1100);
  },
  destroyed() {
    this.timer && clearTimeout(this.timer);
  },
  methods: {
    dragStart() {
      this.$refs.div.style.transition = "none";
    },
    dragEnd() {
      this.$refs.div.style.transition = "all 0.3s";
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - this.itemWidth - this.gapWidth;
      } else {
        this.left = this.gapWidth;
      }
      if (this.top < 10) {
        this.top = 10;
      }
      if (this.top > this.clientHeight - this.itemHeight - 10) {
        this.top = this.clientHeight - this.itemHeight - 10;
      }
    },
    dragProgress(e) {
      if (e.targetTouches.length === 1) {
        let touch = e.targetTouches[0];
        this.left = touch.clientX - this.itemWidth / 2;
        this.top = touch.clientY - this.itemHeight / 2;
      }
    },
    clickButton(e) {
      this.$emit("clickButton", e);
    },
  },
};
</script>
<style lang="less">
.float-btn {
  color: #666;
  z-index: 10;
  transition: all 0.3s;
  position: fixed;
  right: 0;
  bottom: 181/100rem;
  white-space: nowrap;
  width: 143/100rem;
  height: 143/100rem;
  img {
    width: 143/100rem;
    height: 143/100rem;
    margin: auto;
  }
}
</style>
